import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Salespeople from "@/pages/admin/Salespeople";
import Approvals from "@/pages/admin/Approvals";
import Reports from "@/pages/admin/Reports";
import Settings from "@/pages/admin/Settings";
import AdminLeaves from "@/pages/admin/AdminLeaves";
import AdminInvoices from "@/pages/admin/AdminInvoices";
import Audit from "@/pages/admin/Audit";
import ChangePassword from "@/pages/ChangePassword";
import SalesDashboard from "@/pages/sales/SalesDashboard";
import Invoices from "@/pages/sales/Invoices";
import NewInvoice from "@/pages/sales/NewInvoice";
import MyLeaves from "@/pages/sales/MyLeaves";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/salespeople" element={<ProtectedRoute role="admin"><Salespeople /></ProtectedRoute>} />
          <Route path="/admin/approvals" element={<ProtectedRoute role="admin"><Approvals /></ProtectedRoute>} />
          <Route path="/admin/reports" element={<ProtectedRoute role="admin"><Reports /></ProtectedRoute>} />
          <Route path="/admin/invoices" element={<ProtectedRoute role="admin"><AdminInvoices /></ProtectedRoute>} />
          <Route path="/admin/leaves" element={<ProtectedRoute role="admin"><AdminLeaves /></ProtectedRoute>} />
          <Route path="/admin/audit" element={<ProtectedRoute role="admin"><Audit /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute role="admin"><Settings /></ProtectedRoute>} />
          <Route path="/admin/password" element={<ProtectedRoute role="admin"><ChangePassword /></ProtectedRoute>} />

          {/* Shared (admin + salesperson + data_entry) */}
          <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
          <Route path="/invoices/new" element={<ProtectedRoute><NewInvoice /></ProtectedRoute>} />
          <Route path="/leaves" element={<ProtectedRoute><MyLeaves /></ProtectedRoute>} />
          <Route path="/password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />

          {/* Salesperson + Admin dashboard (no aggregates for data_entry) */}
          <Route path="/dashboard" element={<ProtectedRoute role="salesperson"><SalesDashboard /></ProtectedRoute>} />

          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
